import { Auth, MyAccount } from "@cleeng/mediastore-sdk";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logout from "../../../components/Logout";
import { API_URL } from "../../../constants";
import { axiosConfig } from "../../../utils";
import { getExpiringItem } from "../../../utils/expiringLocalStorage";

function MyAccountPage() {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const planDetails = useSelector(state => state.planDetails)
  const { search, pathname } = useLocation();
  const query = new URLSearchParams(search);

  // Hide "Change Plan" header and upgrade options if fromApp is true
  useEffect(() => {
    const fromApp = getExpiringItem("fromApp");
    console.log("fromApp value:", fromApp, typeof fromApp);
    if (fromApp === true) {
      const style = document.createElement('style');
      style.setAttribute('data-hide-change-plan', 'true');
      style.innerHTML = `
        h1.sc-fHjqPf.hmtbKo.msd__section-header[data-hide-change-plan], .msd__account-sidebar__item[data-hide-change-plan] {
          display: none !important;
        }
        /* Hide .sc-gEkIjz.msd__account__subscription only if NOT a direct child of any .sc-eXsaLi (even with extra classes) */
        :not([class*="sc-eXsaLi"]) > .sc-gEkIjz.msd__account__subscription {
          display: none !important;
        }
        [class*="sc-eXsaLi"] > .sc-gEkIjz.msd__account__subscription {
          display: revert !important;
        }
      `;
      document.head.appendChild(style);

      // Hide sidebar item with label "Your Payments"
      const hideSidebarItem = () => {
        const sidebarItems = document.querySelectorAll('.msd__account-sidebar__item');
        sidebarItems.forEach(item => {
          const label = item.querySelector('.msd__account-sidebar__label');
          if (label && label.textContent.trim() === "Your Payments") {
            item.setAttribute('data-hide-change-plan', '');
          }
        });
      };

      // Directly mark the header for hiding
      const tryHide = () => {
        const headers = document.querySelectorAll('h1.sc-fHjqPf.hmtbKo.msd__section-header');
        headers.forEach(h => {
          if (h.textContent.trim() === "Change Plan") {
            h.setAttribute('data-hide-change-plan', '');
          }
        });
        hideSidebarItem();
      };
      tryHide();
      setTimeout(tryHide, 500);
      setTimeout(tryHide, 1200);
      return () => {
        if (style.parentNode) style.parentNode.removeChild(style);
      };
    }
  }, []);

  const tab = query.get("tab");
  const customCancellationReasons = [
    { value: "My child has grown out of it", key: "grown-out" },
    { value: "Subscription is too expensive", key: "expensive" },
    { value: "Technical issues", key: "technical-issues" },
    { value: "Poor customer support", key: "customer-support" },
    { value: "Other", key: "Other" },
  ];
  const getOffers = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/offers?status=active&pageLimit=3`,
        axiosConfig(),
      );

      const listPlans = (res && res.data && res.data.responseData) || [];
      return listPlans;
    } catch (error) {
    }
  };
  const key = localStorage.getItem("CLEENG_CUSTOMER_EMAIL");

  const handleShowImages = React.useCallback(async () => {
    const res = await getOffers();
    setPlans(res || []);
  }, []);

  useEffect(() => {
    if (!Auth.isLogged()) {
      localStorage.setItem('save_redirect_url', pathname + search)
      navigate("/", { replace: true });
    }
    handleShowImages()
    const menu = document.querySelectorAll(".msd__account-sidebar__items>div")
    menu.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        navigate(['/my-account', '/my-account?tab=your-payments', '/my-account?tab=update-profile'][index])
      });
    })
    document.title = "My Account - Super Simple";
    const description = document.querySelector('meta[name="description"');
    description.setAttribute("content", "Manage your Super Simple App account");
    // eslint-disable-next-line
    return () => {
      document.title = "Accounts - Super Simple";
      description.setAttribute("content", "Super Simple App account creation and management");
    }
  }, [handleShowImages, navigate, pathname, search]);

  useEffect(() => {
    if (tab) {
      const menu = document.querySelectorAll(".msd__account-sidebar__items>div")
      const activeMenu = ({
        'your-payments': menu[1],
        'update-profile': menu[2]
      }[tab])
      activeMenu && activeMenu.click()
    }
  }, [tab])

  useEffect(() => {
    if (planDetails && planDetails.currentPlan && !planDetails.currentPlan.length) {
      const box = document.querySelector('.msd__info-box')

      const pushUrl = (href) => {
        window.history.pushState({}, '', href);
        window.dispatchEvent(new Event('popstate'));
      };
      if (box) {
        const btn = document.querySelector('btn.msd__button.msd__button--confirm')
        const createButton = document.createElement('button')
        createButton.innerText = 'Choose a plan'
        createButton.className = "btn msd__button msd__button--confirm";
        createButton.onclick = () => pushUrl(`/choose-plan`)
        !btn && box.appendChild(createButton)
      }
    }
  }, [planDetails])

  useEffect(() => {
    if (plans && plans.length) {
      const intervalId = setInterval(() => {
        const selectors = document.querySelectorAll('.msd__subscription-card__icon')
        const titleElements = document.querySelectorAll('.msd__subscription-text__title')
        const priceIndexs = []
        titleElements.forEach(e => {
          const index = plans.findIndex(p => p.title === e.innerText);
          priceIndexs.push(index)
        })
        for (let index = 0; index < selectors.length; index++) {
          const selector = selectors[index];
          const offer = plans[priceIndexs[index]]
          if (offer) {
            selector.style = `background-image: url("${offer.imageUrl}");background-size: cover;color: transparent;`
          }
        }
      }, 400)
      return () => clearInterval(intervalId);
    }
  }, [plans])

  // Set fromApp in localStorage if ?fromApp=true in URL
  useEffect(() => {
    const fromAppParam = query.get("fromApp");
    if (fromAppParam === "true") {
      // Use the same utility as other pages
      import("../../../utils/expiringLocalStorage").then(({ setExpiringItem }) => {
        setExpiringItem("fromApp", true); // 2 hours default
        console.log("fromApp set to true in localStorage");
      });
    } else if (fromAppParam === "false") {
      import("../../../utils/expiringLocalStorage").then(({ removeExpiringItem }) => {
        removeExpiringItem("fromApp");
        console.log("fromApp removed from localStorage");
      });
    }
  }, [query]);

  return (
    <>
      <Logout />
      <MyAccount
        key={key}
        customCancellationReasons={customCancellationReasons}
        skipAvailableDowngradesStep
        displayGracePeriodError
      />
    </>
  );
}

export default MyAccountPage;
